import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'

const MultimediaPlayerPrivacyPolicy = () => {
    return (
        <div className="multimedia-page">

            {/* Header */}
            <nav className="navbar navbar-expand-lg navbar-dark custom-navbar px-3 px-lg-5">
                <div className="container-fluid">

                    <a
                        className="navbar-brand d-flex align-items-center gap-3"
                        href="/"
                    >
                        <img
                            src="../images/icon/icon2-multimediaPlayer.png"
                            alt="Multimedia Player"
                            className="music-logo"
                        />

                        <div>
                            <h2 className="brand-title mb-0">
                                Multimedia Player
                            </h2>

                            <p className="brand-subtitle mb-0">
                                Offline Video & Audio Experience
                            </p>
                        </div>
                    </a>
                                <ul className="navbar-nav gap-lg-4 text-center mt-4 mt-lg-0">

              <li className="nav-item">
                <a className="nav-link custom-link" href="/">
                  Home
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link custom-link" href="/">
                  Features
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link custom-link" href="/">
                  Matches
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link custom-link" href="/">
                  Contact
                </a>
              </li>

            </ul>

                </div>
            </nav>

            <main className="body-section">
                <div className="container text-center">
                    <div className="empty-body-box">

                        <img
                            src="../images/icon/icon2-multimediaPlayer.png"
                            alt="Multimedia Player"
                            className="body-logo"
                        />

                        <h1 className="body-title">
                            Multimedia Player - Privacy Policy
                        </h1>
                        <p className="body-text">
                        Your privacy is important to us. Multimedia Player is designed to provide a secure and privacy-focused media playback experience. We do not collect, store, sell, rent, or share personal information such as your name, email address, phone number, contacts, passwords, payment information, or location data.

                        The application requires access to media files stored on your device in order to discover, organize, and play video and audio content. All media files remain on your device and are never uploaded to our servers.

                        To provide uninterrupted playback, Multimedia Player may use Android foreground media services. This allows audio and video playback to continue while the application is running in the background. A media playback notification may be displayed so users can control playback directly from the notification panel.

                        The application may request notification permission to display playback controls, media status information, and other media-related notifications required for proper functionality. Notification access is used solely for app features and is not used for advertising or marketing purposes.

                        Multimedia Player may use wake lock functionality to prevent playback interruptions while media is actively playing. This helps ensure a smooth listening and viewing experience by keeping essential device processes active during playback.

                        Some features may use Android overlay capabilities when explicitly enabled by the user. Overlay functionality is used only to support media-related features and user experience enhancements. No information is collected through overlay permissions.

                        The application does not track your viewing habits, listening habits, personal preferences, or device activity for advertising purposes. We do not use intrusive tracking technologies and do not share user data with third parties except where required by law.

                        If advertisements are provided through third-party advertising networks, those providers may collect limited device information in accordance with their own privacy policies. Users are encouraged to review the privacy policies of any third-party advertising services used within the application.

                        Our goal is to provide a lightweight, reliable, and privacy-respecting multimedia experience. Any future features requiring additional permissions will be clearly disclosed before access is requested. By using Multimedia Player, you agree to the terms of this Privacy Policy.
                        </p>

                    </div>
                </div>
            </main>

            <footer className="footer-section">
                <div className="container">

                    <div className="row gy-5 body-text">

                        <div className="col-lg-4">
                            <h3 className="footer-title">
                                Multimedia Player
                            </h3>

                            <p className="footer-description">
                                Play videos and music with a modern, fast,
                                and privacy-focused multimedia experience.
                            </p>
                        </div>

                        <div className="col-lg-4">
                            <h4 className="footer-heading">
                                Quick Links
                            </h4>

                            <ul className="footer-links">
                                <li><a href="/">Home</a></li>
                                <li><a href="/">Privacy Policy</a></li>
                                <li><a href="/">Support</a></li>
                            </ul>
                        </div>

                        <div className="col-lg-4">
                            <h4 className="footer-heading">
                                Contact
                            </h4>

                            <ul className="footer-contact">
                                <li>Email: newrahulgautam@gmail.com</li>
                                <li>India</li>
                            </ul>
                        </div>

                    </div>

                    <div className="copyright-area">
                        © 2026 Multimedia Player. All Rights Reserved.
                    </div>

                </div>
            </footer>

            <style>{`

        :root {
          --bg-color: #0f172a;
          --card-color: #111827;
          --border-color: #1e293b;
          --text-color: #ffffff;
          --secondary-text: #94a3b8;
          --accent-color: #06b6d4;
          --hover-color: #0891b2;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          background: var(--bg-color);
        }

        .music-page {
          min-height: 100vh;
          background: var(--bg-color);
          color: var(--text-color);
          display: flex;
          flex-direction: column;
        }

        .custom-navbar {
          background: var(--card-color);
          border-bottom: 1px solid var(--border-color);
          padding-top: 16px;
          padding-bottom: 16px;
        }

        .music-logo {
          width: 60px;
          height: 60px;
          border-radius: 18px;
          object-fit: cover;
        }

        .brand-title {
          font-size: 28px;
          font-weight: 700;
          color: var(--text-color);
        }

        .brand-subtitle {
          font-size: 14px;
          color: var(--secondary-text);
        }

        .custom-link {
          color: var(--secondary-text) !important;
          transition: 0.3s;
          font-size: 16px;
        }

        .custom-link:hover {
          color: var(--accent-color) !important;
        }

        .body-section {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 80px 20px;
        }

        .empty-body-box {
          background: var(--card-color);
          border: 1px solid var(--border-color);
          border-radius: 32px;
          padding: 60px 30px;
          max-width: 700px;
          margin: auto;
        }

        .body-logo {
          width: 140px;
          height: 140px;
          border-radius: 32px;
          margin-bottom: 30px;
        }

        .body-title {
          font-size: 56px;
          font-weight: 800;
          margin-bottom: 20px;
          color: gray;
        }

        .body-text {
          color: var(--secondary-text);
          font-size: 20px;
          line-height: 1.8;
        }

        .footer-section {
          background: var(--card-color);
          border-top: 1px solid var(--border-color);
          padding: 70px 0 30px;
        }

        .footer-logo {
          width: 60px;
          height: 60px;
          border-radius: 18px;
        }

        .footer-title {
          font-size: 28px;
          font-weight: 700;
        }

        .footer-subtitle {
          color: var(--secondary-text);
          font-size: 14px;
        }

        .footer-description {
          color: var(--secondary-text);
          line-height: 1.8;
          font-size: 16px;
        }

        .footer-heading {
          font-size: 24px;
          margin-bottom: 24px;
          font-weight: 700;
        }

        .footer-links,
        .footer-contact {
          list-style: none;
          padding: 0;
        }

        .footer-links li,
        .footer-contact li {
          margin-bottom: 16px;
          color: var(--secondary-text);
        }

        .footer-links a {
          color: var(--secondary-text);
          text-decoration: none;
          transition: 0.3s;
        }

        .footer-links a:hover {
          color: var(--accent-color);
        }

        .copyright-area {
          border-top: 1px solid var(--border-color);
          margin-top: 50px;
          padding-top: 24px;
          text-align: center;
          color: var(--secondary-text);
          font-size: 15px;
        }

        @media (max-width: 991px) {

          .brand-title {
            font-size: 24px;
          }

          .body-title {
            font-size: 42px;
          }

          .body-text {
            font-size: 18px;
          }

        }

        @media (max-width: 576px) {

          .music-logo,
          .footer-logo {
            width: 50px;
            height: 50px;
          }

          .body-logo {
            width: 110px;
            height: 110px;
          }

          .brand-title {
            font-size: 20px;
          }

          .body-title {
            font-size: 34px;
          }

          .body-text {
            font-size: 16px;
          }

          .empty-body-box {
            padding: 40px 20px;
          }

        }

      `}</style>

        </div>
    )
}

export default MultimediaPlayerPrivacyPolicy